import React from 'react';
import { ArrowRight } from 'lucide-react';
import { images } from '../../data/blackout';
import { useBundle } from '../../contexts/BundleContext';
import { scrollToSection } from '../../utils/scroll';
const crewWords = ['Friends', 'Riders', 'Couples', 'Crews', 'Events', 'Content'];
export function CrewSection() {
  const {
    selectBundle
  } = useBundle();
  return <section className="border-t border-gunmetal/60 bg-obsidian" data-id="element-123" data-mp="1opygtxg2ibey">
      <div className="grid lg:grid-cols-2" data-id="element-124" data-mp="23jben0owjhy6">
        <div className="relative aspect-[4/3] overflow-hidden bg-carbon lg:aspect-auto lg:min-h-[620px]" data-id="element-125" data-mp="1ylt2z2ji2omh">
          <img src={images.crewFlag} alt="Graphic-novel illustration of a masked crew in front of an American flag" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-126" data-mp="2ccy6ifpzo123" />
        </div>
        <div className="flex flex-col justify-center px-5 py-16 md:px-8 lg:py-20 lg:pl-16 lg:pr-[max(2rem,calc((100vw-80rem)/2+2rem))]" data-id="element-127" data-mp="2mbne9fo6854m">
          <h2 className="font-display text-5xl uppercase leading-[0.92] text-bone md:text-7xl" data-id="element-128" data-mp="t8azdhfped0i">
            One mask changes your look.
            <span className="block text-steel" data-id="element-129" data-mp="y7xb1mfvvl77">A unit changes the room.</span>
          </h2>

          <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2 font-display text-2xl uppercase text-bone/85 md:text-3xl" data-id="element-130" data-mp="1355tlo4y1r8z">
            {crewWords.map(word => <li key={word} data-id="element-131" data-mp="1c76rmn804hbp">{word}.</li>)}
          </ul>

          <button type="button" onClick={() => {
          selectBundle('crew');
          scrollToSection('bundles');
        }} className="group mt-10 inline-flex h-14 items-center justify-center gap-3 self-start border border-bone px-8 text-[13px] font-semibold uppercase tracking-[0.2em] text-bone transition-[background-color,color] duration-150 hover:bg-bone hover:text-obsidian" data-id="element-132" data-mp="1c4sywl0snh7b">
            Don’t go alone
            <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="1zx9ij006jh8q" />
          </button>
        </div>
      </div>
    </section>;
}